/**
 * ScreenshotWatermark — near-invisible repeating diagonal watermark rendered
 * above every page. Doesn't block clicks (pointer-events: none) and is subtle
 * on screen, but shows up clearly in screenshots/photos of the app. When a
 * user is logged in their email is embedded so leaked captures are traceable.
 */
import React, { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

const xmlEscape = (s) =>
  String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export default function ScreenshotWatermark() {
  const { user } = useAuth();
  const label = user?.email ? `RESMO · ${user.email}` : "RESMO · CONFIDENTIAL";

  const bg = useMemo(() => {
    const text = xmlEscape(label.toUpperCase());
    const svg =
      `<svg xmlns="http://www.w3.org/2000/svg" width="520" height="320">` +
      `<g transform="rotate(-30 260 160)" fill="#8090A5" ` +
      `font-family="ui-monospace, Menlo, Consolas, monospace" font-size="15" ` +
      `letter-spacing="5" font-weight="600">` +
      `<text x="20" y="100">${text}</text>` +
      `<text x="-180" y="260">${text}</text>` +
      `</g></svg>`;
    return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
  }, [label]);

  return (
    <div
      aria-hidden="true"
      data-testid="screenshot-watermark"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483000,
        pointerEvents: "none",
        backgroundImage: bg,
        backgroundRepeat: "repeat",
        opacity: 0.08,
      }}
    />
  );
}
